// Import react
import React, { useState, useEffect } from "react";

// Import states, contexts, and CSS
import { useActiveUser } from "../../store/activeUserContext";
import { SpinnerGeneric } from "../../utils/general/spinners";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import {
  PlusCircle,
  XCircle,
  ArrowClockwise,
  FunnelFill,
} from "react-bootstrap-icons";
import Pagination from "react-bootstrap/Pagination";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";

import styles from "./itemListFilter.module.scss";

const ColumnSelector = ({ columns, setColumns, setUpdate }) => {
  // Get variables from local storage
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  // Get user data from context
  const { activeUser, setActiveUser } = useActiveUser();

  const [isSaving, setIsSaving] = useState(false);

  const [localColumns, setLocalColumns] = useState([...columns]);

  const handleToggleColumn = (index, checked) => {
    const updated = [...localColumns];
    updated[index] = {
      ...updated[index],
      show: checked,
    };
    setLocalColumns(updated);
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...localColumns];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    setLocalColumns(updated);
  };

  const moveDown = (index) => {
    if (index === localColumns.length - 1) return;
    const updated = [...localColumns];
    [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
    setLocalColumns(updated);
  };

  // Funzione di confronto profondo tra arrays
  const arraysAreEqual = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every(
      (el, idx) =>
        el.field === b[idx].field &&
        el.headerName === b[idx].headerName &&
        el.show === b[idx].show
    );
  };

  const isModified =
    columns.length > 0 && !arraysAreEqual(columns, localColumns);

  // Handle form submission
  const handleConfirmEdit = async () => {
    setIsSaving(true); // opzionale, se stai usando uno spinner
    try {
      const body = {
        itemListColumns: localColumns, // inviamo la chiave corretta
      };
  
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/users/${userId}/itemscolumns`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        }
      );
  
      if (!response.ok) {
        throw new Error("Errore durante l'aggiornamento delle colonne.");
      }
  
      alert("Modifica completata con successo!");
  
      const updatedProfile = await response.json();
      setActiveUser(updatedProfile);
      setColumns(localColumns); // aggiorna le colonne visivamente
    } catch (error) {
      console.error(error);
      alert("Errore durante la modifica.");
    } finally {
      setUpdate((prevUpdate) => !prevUpdate);
      setIsSaving(false); // opzionale, se stai usando uno spinner
    }
  };
  

  return (
    <>
      <Table hover size="sm">
        <thead>
          <tr>
            <th>Colonna</th>
            <th>Mostra</th>
            <th>Ordina</th>
          </tr>
        </thead>
        <tbody>
          {isSaving ? (
            <SpinnerGeneric />
          ) : (
            localColumns.map((col, index) => (
              <tr key={col.field}>
                <td>{col.headerName}</td>
                <td className="text-center">
                  <Form.Check
                    type="checkbox"
                    checked={col.show}
                    onChange={(e) =>
                      handleToggleColumn(index, e.target.checked)
                    }
                  />
                </td>
                <td className="text-center">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="me-1"
                    onClick={() => moveUp(index)}
                    disabled={index === 0}
                  >
                    ↑
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => moveDown(index)}
                    disabled={index === localColumns.length - 1}
                  >
                    ↓
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {isModified && (
        <div className="text-end mt-2">
          <Button
            variant="success"
            size="sm"
            onClick={handleConfirmEdit}
            disabled={isSaving}
          >
            {isSaving ? "Salvataggio..." : "Salva"}
          </Button>
        </div>
      )}
    </>
  );
};

export default ColumnSelector;
